import { NgModule } from "@angular/core";
import { PasswordValidationModalComponent } from "./password-validation-modal.component";
import { CoreModule } from "../../../core/core.module";

const components = [PasswordValidationModalComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class PasswordValidationModule {}
